import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { SigmaLogoText } from "@/components/brand/sigma-logo-text";
import { ModeToggle } from "@/components/mode-toggle";
import { getBrandConfig } from "@/lib/brand-config";
interface AuthNavbarProps {
  oauthClientName?: string;
}
export function AuthNavbar(t0) {
  const $ = _c(7);
  const {
    oauthClientName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getBrandConfig();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const brandConfig = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link className="flex min-w-0 items-center gap-2 font-medium text-sm" href="/">{brandConfig.logoUrl ? <><Image alt={`${brandConfig.name} logo`} className="h-6 w-auto shrink-0" height={24} src={brandConfig.logoUrl} width={24} /><span className="truncate text-muted-foreground">{brandConfig.name}</span></> : <><SigmaLogoText className="h-5 w-auto shrink-0 text-foreground" height={20} width={88} /><span className="sr-only">{brandConfig.name}</span></>}</Link>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== oauthClientName) {
    t3 = oauthClientName ? <span className="max-w-[30vw] truncate font-medium text-sm sm:max-w-xs">{oauthClientName}</span> : null;
    $[2] = oauthClientName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ModeToggle />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <nav className="border-b"><div className="mx-auto flex min-w-0 max-w-7xl items-center justify-between gap-2 px-4 py-3">{t2}<div className="flex shrink-0 items-center gap-2">{t3}{t4}</div></div></nav>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}